<template>
	<div class="hwk-login">
		<div class="login-main">
			<div class="logo"><img src="@/assets/logo.png" alt="" /></div>
			<div class="middle" v-show="isWeiXin">
				<div class="back" @click="isWeiXin = false">
					<i class="el-icon-arrow-left"></i>返回
				</div>
				<ul class="m-nav">
					<li class="on">微信登录</li>
				</ul>
				<div class="wx-main">
					<div id="login_container"></div>
					<!-- <img src="@/assets/ma.png" alt="" /> -->
					<p>使用微信扫码登录</p>
				</div>
			</div>
			<div class="middle" v-if="!isWeiXin">
				<ul class="m-nav">
					<li :class="{ on: index == 0 }" @click="changeIndex(0)">账号/邮箱登录</li>
					<li :class="{ on: index == 1 }" @click="changeIndex(1)">手机号密码登录</li>
				</ul>
				<div class="m-main" v-if="index == 0">
					<div class="from">
						<form>
							<div class="item">
								<img src="@/assets/login1.png" />
								<input type="text" v-model="account" placeholder="请输入账号/邮箱">
							</div>
							<div class="item">
								<img src="@/assets/login2.png" />
								<input type="password" v-model="password" placeholder="请输入密码">
							</div>
							<div class="item">
								<img src="@/assets/login3.png" />
								<input type="text" placeholder="请输入验证码" v-model="code">
								<div class="yzm" @click="getimgcode">
									<img :src="yzmImg" />
								</div>
							</div>

							<div class="btn" @click="login(1)">
								登录
							</div>
						</form>
					</div>
				</div>
				<div class="m-main" v-if="index == 1">
					<div class="from">
						<form>
							<div class="item">
								<img src="@/assets/login4.png" />
								<input type="number" v-model="mobile" placeholder="请输入手机号">
							</div>
							<div class="item">
								<img src="@/assets/login2.png" />
								<input type="password" v-model="password" placeholder="请输入密码">
							</div>
							<!-- <div class="item">
								<img src="@/assets/login3.png" />
								<input type="text" v-model="code" placeholder="请输入验证码">
								<span @click="sendMsg" :class="{on:again_send}">{{codeText}}</span>
							</div> -->

							<div class="btn" @click="login(2)">
								登录
							</div>
						</form>
					</div>
				</div>
				<div class="or">or</div>
				<div class="wx" @click="handleWEIXIN">
					<img src="@/assets/wx.png" /><span>微信</span>
				</div>
			</div>
			<div class="register">
				还没有账号?<router-link to="register">立即注册</router-link>
			</div>
		</div>
		<div class="bottom_a">
			东莞市博跃达科技有限公司
			<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">粤ICP备2023089948</a>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			list: [],
			pageSize: 0,
			page: 1,
			index: 0,
			isWeiXin: false,
			again_send: true,
			mobile: "",
			code: "",
			codeText: '获取验证码',
			password: '',
			account: '',
			yzmImg: '',
			rand: "",
			wxcode: ""

		};
	},
	created() {
		// this.getlist();
		if (this.$route.query.code) {
			console.log('------------微信登录------------------')
			this.wxcode = this.$route.query.code
			this.wxLogin()
		}
		this.getimgcode()


	},
	mounted() {

	},
	methods: {
		handleWEIXIN() {
			var obj = new WxLogin({
				self_redirect: false,
				id: "login_container",
				appid: "wxb21dbd51e2a8da43",
				scope: "snsapi_login",
				redirect_uri: encodeURIComponent("https://www.boyueda.vip/login"),
				state: "",
				style: "black",
				href: "",
				onReady: function (isReady) {
					console.log(isReady);
				}
			});
			this.isWeiXin = true
		},
		getimgcode() {
			function getRandom5DigitString() {
				const num = Math.floor(10000 + Math.random() * 90000);
				return num.toString(); // 返回字符串形式
			}
			this.rand = getRandom5DigitString()
			this.$http.get('/api/index/code_send', {
				responseType: 'blob',
				params: {
					rand: this.rand
				}
			}).then(res => {
				this.yzmImg = URL.createObjectURL(res);
			});
		},
		wxLogin() {
			this.$http.post('/api/user/wechat_login', {
				code: this.wxcode
			}).then(res => {
				if (res.code == 1) {
					this.$message({
						message: '登录成功',
						type: 'success'
					});
					// 假设token是你想要存储的值
					let token = res.data.userinfo.token;
					localStorage.setItem('token', token);
					let userId = res.data.userinfo.id
					localStorage.setItem('userId', userId);
					localStorage.setItem('userAttest', res.data.userinfo.is_attestation);
					let nickname = res.data.userinfo.nickname
					localStorage.setItem('nickname', nickname);
					localStorage.setItem('userinfo', JSON.stringify(res.data.userinfo));
					this.$store.dispatch('setUserInfo', res.data.userinfo);
					// 使用getItem方法获取token
					//let token = localStorage.getItem('token');
					// 当用户登出时，可以使用removeItem方法删除token
					//localStorage.removeItem('token');
					setTimeout(() => {
						this.$router.push({
							path: "/"
						});
					}, 2000)


				} else {

					this.$message({
						message: res.msg,
						type: 'error'
					});
				}
			});
		},
		login(i) {
			function isValidPhoneNumber(phoneNumber) {
				// 正则表达式，匹配中国大陆手机号
				const phoneRegex = /^1[3-9]\d{9}$/;
				return phoneRegex.test(phoneNumber);
			}
			if (i == 1) {
				if (!this.account) {
					this.$message({
						message: '账号不能为空',
						type: 'warning'
					});
					return
				}
				if (!this.password) {
					this.$message({
						message: '密码不能为空',
						type: 'warning'
					});
					return
				}
				if (!this.code) {
					this.$message({
						message: '验证码不能为空',
						type: 'warning'
					});
					return
				}
				this.$http.post('/api/user/login', {
					account: this.account,
					password: this.password,
					code: this.code,
					rand: this.rand
				}).then(res => {
					if (res.code == 1) {
						this.$message({
							message: '登录成功',
							type: 'success'
						});
						// 假设token是你想要存储的值
						let token = res.data.userinfo.token;
						localStorage.setItem('token', token);
						let userId = res.data.userinfo.id
						localStorage.setItem('userId', userId);
						localStorage.setItem('userAttest', res.data.userinfo.is_attestation);
						let nickname = res.data.userinfo.nickname
						localStorage.setItem('nickname', nickname);
						localStorage.setItem('userinfo', JSON.stringify(res.data.userinfo));
						this.$store.dispatch('setUserInfo', res.data.userinfo);
						let loginTime = new Date().getTime()
						localStorage.setItem('loginTime', loginTime);
						// 使用getItem方法获取token
						//let token = localStorage.getItem('token');
						// 当用户登出时，可以使用removeItem方法删除token
						//localStorage.removeItem('token');


						setTimeout(() => {
							this.$router.push({
								path: "/"
							});
						}, 2000)
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
						this.getimgcode()
						this.code = ''

					}
				});
			} else {
				if (!this.mobile) {
					this.$message({
						message: '手机号不能为空',
						type: 'warning'
					});
					return
				}
				if (this.mobile && !isValidPhoneNumber(this.mobile)) {
					this.$message({
						message: '手机号格式错误',
						type: 'warning'
					});
					return
				}
				if (!this.password) {
					this.$message({
						message: '密码不能为空',
						type: 'warning'
					});
					return
				}

				this.$http.post('/api/user/login_mobile', {
					mobile: this.mobile,
					password: this.password,
				}).then(res => {
					if (res.code == 1) {
						this.$message({
							message: '登录成功',
							type: 'success'
						});
						// 假设token是你想要存储的值
						let token = res.data.userinfo.token;
						localStorage.setItem('token', token);
						let userId = res.data.userinfo.id
						localStorage.setItem('userId', userId);
						localStorage.setItem('userAttest', res.data.userinfo.is_attestation);
						let nickname = res.data.userinfo.nickname
						localStorage.setItem('nickname', nickname);
						localStorage.setItem('userinfo', JSON.stringify(res.data.userinfo));
						this.$store.dispatch('setUserInfo', res.data.userinfo);
						let loginTime = new Date().getTime()
						localStorage.setItem('loginTime', loginTime);
						// 使用getItem方法获取token
						//let token = localStorage.getItem('token');
						// 当用户登出时，可以使用removeItem方法删除token
						//localStorage.removeItem('token');
						setTimeout(() => {
							this.$router.push({
								path: "/"
							});
						}, 2000)


					} else {

						this.$message({
							message: res.msg,
							type: 'error'
						});
					}
				});
			}

		},
		sendMsg() {
			function isValidPhoneNumber(phoneNumber) {
				// 正则表达式，匹配中国大陆手机号
				const phoneRegex = /^1[3-9]\d{9}$/;
				return phoneRegex.test(phoneNumber);
			}
			if (!this.mobile) {
				this.$message({
					message: '手机号不能为空',
					type: 'warning'
				});
				return
			}
			if (this.mobile && !isValidPhoneNumber(this.mobile)) {
				this.$message({
					message: '手机号格式错误',
					type: 'warning'
				});
				return
			}
			if (!this.again_send) {
				this.$message({
					message: '请稍后再获取',
					type: 'warning'
				});
				return
			}
			this.again_send = false;
			this.$http.post('/api/index/sms_send', {
				mobile: this.mobile,
				event: "mobile_login"
			}).then(res => {
				if (res.code == 1) {
					let num = 60;
					timer = setInterval(() => {
						num--;
						this.codeText = num + 's后重发';
						if (num == 0) {
							clearInterval(timer);
							this.codeText = '重新发送';
							this.again_send = true
						}
					}, 1000)
					this.$message({
						message: '验证码发送成功',
						type: 'success'
					});
				} else {
					this.again_send = true
				}
			});
		},


		changeIndex(i) {
			this.index = i
		},
		toDetails(id) {
			// this.$router.push({
			// 	path: `/details/${id}`
			// });
			// this.$router.push({
			// 	name: "details",
			// 	params: {
			// 		id: id
			// 	}
			// });
			this.$router.push({
				path: "/details",
				query: {
					id: id
				}
			});
		},

	},
};
</script>
<style lang="less" scoped>
@color: #FF6A00;

.hwk-login {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #333 url(../assets/bg2.png) center top no-repeat;
	background-size: cover;

	.bottom_a {
		position: absolute;
		bottom: 10px;
		left: 50%;
		transform: translate(-50%);
		color: #fff;
		font-size: 12px;

		a {
			color: #fff;
			font-size: 12px;
		}
	}

	.login-main {
		position: absolute;
		right: 0;
		top: 0;
		bottom: 0;
		width: 620px;
		background-color: #fff;
		padding: 160px 110px 60px;
		box-sizing: border-box;

		.register {
			position: absolute;
			bottom: 100px;
			left: 80px;
			text-align: left;
			font-size: 16px;
			height: 30px;
			line-height: 30px;
			color: #3F3F3F;

			a {
				color: #3572F5;
				text-decoration: none;
			}
		}

		.logo {
			width: 355px;
			height: 36px;
			margin: 0 auto 30px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.middle {
			width: 100%;
			margin: 30px auto;
			position: relative;

			.back {

				height: 20px;
				position: absolute;
				top: 10px;
				left: 0;
				cursor: pointer;
				display: flex;
				align-items: center;
				font-size: 14px;
				color: #666;
				z-index: 999;

				i {
					margin-right: 5px;
				}

			}

			.wx-main {
				margin: 30px auto;
				width: 260px;
				text-align: center;

				img {
					width: 260px;
					height: 260px;
				}

				p {
					font-size: 20px;
					color: #A9A9A9;
					height: 40px;
					line-height: 40px;
					margin-top: 20px;
				}
			}

			.or {
				padding: 30px;
				text-align: center;
				font-size: 14px;
				color: #666;
				position: relative;

				&::after {
					content: '';
					position: absolute;
					top: 50%;
					left: 0;
					width: 45%;
					height: 1px;
					background-color: #eee;
				}

				&::before {
					content: '';
					position: absolute;
					top: 50%;
					right: 0;
					width: 45%;
					height: 1px;
					background-color: #eee;
				}
			}

			.wx {
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: center;
				border: 1px solid #eee;
				border-radius: 5px;
				height: 40px;
				line-height: 40px;
				cursor: pointer;

				img {
					width: 30px;
					height: 30px;
				}

				span {
					font-size: 20px;
					margin-left: 10px;
					color: #3F3F3F;
				}
			}

			.btn {
				width: 100%;
				height: 50px;
				line-height: 50px;
				text-align: center;
				background-color: @color;
				font-size: 20px;
				color: #fff;
				border-radius: 4px;
				cursor: pointer;

				&:hover {
					background-color: #cf9236;
				}
			}


			.m-nav {
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: center;
				border-bottom: 1px solid #eee;
				height: 40px;
				line-height: 40px;

				li {
					flex: 1;
					color: #A9A9A9;
					font-size: 20px;

					cursor: pointer;
				}

				.on {
					color: @color;
					font-weight: 600;
					position: relative;

					&::after {
						content: '';
						position: absolute;
						bottom: 0;
						left: 50%;
						width: 50px;
						height: 3px;
						border-radius: 1px;
						background-color: @color;
						margin-left: -24px;
					}
				}
			}

			.m-main {
				margin-top: 40px;

				.item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					height: 50px;
					line-height: 50px;
					margin-bottom: 20px;
					border: 1px solid #F5F5F5;
					padding: 5px 10px;
					border-radius: 2px;

					img {
						width: 24px;
						height: 24px;
					}

					input {
						flex: 1;
						width: 1rpx;
						border: none;
						height: 50px;
						line-height: 50px;
						background-color: #fff;
						margin-left: 10px;
					}

					span {
						font-size: 14px;
						color: #999;
					}

					.on {

						color: @color;
					}

					.yzm {
						width: 150px;
						height: 50px;
						border: 1px solid #F5F5F5;

						img {
							width: 100%;
							height: 100%;
						}
					}
				}
			}
		}
	}
}
</style>